const single = "เตียงเดี่ยว"
const twin = "เตียงคู่"
const double = "Double Bed"
const queenSize = "Queen Size Bed"
const kingSize = "King Size Bed"
const extra = "เตียงเสริม"

export const bedType = { single, twin, double, queenSize, kingSize, extra }
export const bedTypeArray = [single, twin, double, queenSize, kingSize, extra]
